export const API_CONSTANT = Object.freeze({
  BASE_URL: 'https://www.invishost.in/ktapi/api'
});